import React from "react";
import { ProductEntry } from "./components/product-entry";
export function OrderProducts({ products, productCount = 0 }) {
    return (React.createElement("div", { className: "flex flex-col gap-4 px-4 py-4" },
        React.createElement("div", { className: "flex gap-2 text-lg" },
            React.createElement("div", { className: "text-primary" }, "Products"),
            React.createElement("div", { className: "text-dark-gray" },
                "(",
                productCount || products?.length || 0,
                ")")),
        React.createElement("div", { className: "w-full grid grid-cols-12" },
            React.createElement("div", { className: "col-span-6 border border-r-0 border-neutral-gray px-8 py-2 bg-light-gray text-gray-700" }, "PRODUCT"),
            React.createElement("div", { className: "col-span-2 border border-x-0 border-neutral-gray px-8 py-2 bg-light-gray text-gray-700" }, "PRICE"),
            React.createElement("div", { className: "col-span-2 border border-x-0 border-neutral-gray px-8 py-2 bg-light-gray text-gray-700" }, "QUANTITY"),
            React.createElement("div", { className: "col-span-2 border border-l-0 border-neutral-gray px-8 py-2 bg-light-gray text-gray-700" }, "SUB-TOTAL"),
            products?.map((product) => (React.createElement(ProductEntry, { key: product?._id, ...product }))))));
}
